import React, { useCallback, useEffect, useState } from 'react';
import classes from './Spinner.css';

const getTimerDuration = (timerDuration) => {
    const parsedDuration = Number(timerDuration);

    if (!Number.isFinite(parsedDuration) || parsedDuration <= 0) {
        return null;
    }

    return Math.ceil(parsedDuration);
};

const formatRemainingTime = (remainingSeconds) => {
    const minutes = Math.floor(remainingSeconds / 60);
    const seconds = remainingSeconds % 60;

    return `${minutes}:${String(seconds).padStart(2, '0')}`;
};

const spinner = (props) => {
    const timerDuration = getTimerDuration(props.timerDuration);
    const shouldRenderTimedSpinner = Boolean(props.showTimer) && timerDuration !== null;
    const [remainingSeconds, setRemainingSeconds] = useState(timerDuration);

    const resetTimer = useCallback(() => {
        if (timerDuration !== null) {
            setRemainingSeconds(timerDuration);
        }
    }, [timerDuration]);

    useEffect(() => {
        if (!shouldRenderTimedSpinner) {
            return undefined;
        }

        setRemainingSeconds(timerDuration);
        return undefined;
    }, [shouldRenderTimedSpinner, timerDuration]);

    useEffect(() => {
        if (!shouldRenderTimedSpinner || props.resetTimerSignal === undefined) {
            return undefined;
        }

        resetTimer();
        return undefined;
    }, [props.resetTimerSignal, resetTimer, shouldRenderTimedSpinner]);

    useEffect(() => {
        if (typeof props.onResetTimerReady !== 'function') {
            return undefined;
        }

        props.onResetTimerReady(resetTimer);

        return () => props.onResetTimerReady(null);
    }, [props.onResetTimerReady, resetTimer]);

    useEffect(() => {
        if (!shouldRenderTimedSpinner || remainingSeconds === null || remainingSeconds <= 0) {
            return undefined;
        }

        const intervalId = setInterval(() => {
            setRemainingSeconds((currentSeconds) => {
                if (currentSeconds === null || currentSeconds <= 0) {
                    return 0;
                }

                return currentSeconds - 1;
            });
        }, 1000);

        return () => clearInterval(intervalId);
    }, [remainingSeconds, shouldRenderTimedSpinner]);

    if (shouldRenderTimedSpinner) {
        return (
            <div className={classes.TimedLoaderWrapper}>
                <svg
                    className={classes.TimedLoaderRing}
                    viewBox="0 0 120 120"
                    aria-hidden="true"
                >
                    <circle
                        className={classes.TimedLoaderArc}
                        cx="60"
                        cy="60"
                        r="48"
                    />
                </svg>
                {!props.hideTimerText && <span className={classes.TimerLabel}>{formatRemainingTime(remainingSeconds)}</span>}
            </div>
        );
    }

    return (
        <div className={classes.Loader}>Loading...</div>
    );
};

export default spinner;